import { classNames } from "@circle-react/helpers/twMergeWithCN";

interface ConversationViewSkeletonLoaderProps {
  wrapperClassName?: string;
}

export const ConversationViewSkeletonLoader = ({
  wrapperClassName = "",
}: ConversationViewSkeletonLoaderProps) => (
  <div
    className={classNames(
      "mt-4 flex flex-1 animate-pulse flex-col justify-start gap-4 px-4",
      wrapperClassName,
    )}
  >
    <div className="flex flex-row items-start gap-1.5">
      <div className="flex flex-1 flex-col gap-2">
        <div className="bg-secondary h-[42px] w-full rounded-2xl" />
      </div>
      <div className="bg-secondary h-4 w-4 shrink-0 rounded-full" />
    </div>

    <div className="flex flex-row items-start gap-1.5">
      <div className="bg-secondary h-4 w-4 shrink-0 rounded-full" />
      <div className="flex flex-1 flex-col gap-2">
        <div className="bg-secondary h-[42px] w-full rounded-2xl" />
      </div>
    </div>
  </div>
);
